import styled from 'styled-components'
import { skeletonAnimation } from 'src/styles'

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: var(--spacer-2);
  padding: 0 var(--spacer-5);
`

Wrapper.displayName = 'Wrapper'

export const Card = styled.div`
  height: 5.625rem;
`

Card.displayName = 'Card'

export const Title = styled.div`
  width: 60%;
  height: 1.1875rem;
  ${skeletonAnimation}
`

Title.displayName = 'Title'

export const Text = styled.div`
  width: 100%;
  height: 0.75rem;
  ${skeletonAnimation}
`

Text.displayName = 'Text'
